<template>
  <div class="basket-page-list-item">
    <div class="basket-page-list-item-details" v-for="(item, index) in listItems" :key="index">
      <div class="row"
        :class="[(listItems.length > index + 1 ? 'border-bottom' : ''), (isContinueShippingModal ? 'py-1' : 'py-3')]">
        <div
          :class="['basket-page-tile-image py-3 basket-page-tile-image-mobile-device', (isContinueShippingModal ? 'col-md-3 col-4' : 'col-xl-2 col-md-6 col-sm-4'), (item.InventoryType === 'paint' ? 'tile-paint' : null)]">
          <div
            v-if="item.ProductTypeDesc && !item.Item.IsTrayItem && !item.IsAdditonalItem && !item.IsIdeaBook && item.InventoryType !== 'paint'">
            <a class="cart-item-model-no" target="_blank" :href="$helpers.getProductDetailUrl(
              slugify(item.SellingStyleName),
              item.Item.SellingStyleNumber,
              item.Item.SellingColorNumber
            )
              ">
              <img :src="item.ImageUrl" class="pc-tile-product-img" alt="" @error="handleImageError" />
            </a>
          </div>
          <div v-else>
            <div v-if="item.InventoryType == 'paint'">
              <div class="pc-tile-product-img"
                :style="{ backgroundColor: item.PaintHex ? '#' + item.PaintHex : '000' }">
              </div>
            </div>
            <div v-else>
              <img :src="item.ImageUrl" class="pc-tile-product-img" alt="patcraft" @error="handleImageError"/>
            </div>
          </div>
        </div>

        <div class="item-details py-3 basket-page-item-details-mobile-device"
          :class="isContinueShippingModal ? 'col-md-9 col-8' : 'col-xl-3 col-md-6 col-sm-8'">
          <div class="pb-md-2">
            <div v-if="
              item.ProductTypeDesc &&
              !item.Item.IsTrayItem &&
              !item.IsAdditonalItem &&
              !item.IsIdeaBook &&
              item.InventoryType !== 'paint'
            " class="list-item-label-row">
              <span>{{ $resourceString["myBasket.ProductList.Label.Style"] }}:</span>
                <template v-if="item.InventoryType.toLowerCase() === 'sundry'">
                <div class="text-uppercase font-weight-bold font-size-item-label">
                  {{ item.SellingStyleName }} {{ item.Item.SellingStyleNumber }}
                </div>
                </template>
                <template v-else>
                <a target="_blank"
                  class="text-decoration-underline cart-item-model-no text-uppercase font-weight-bold font-size-item-label"
                  :href="$helpers.getProductDetailUrl(
                  slugify(item.SellingStyleName),
                  item.Item.SellingStyleNumber,
                  item.Item.SellingColorNumber
                  )">
                  <div>
                  {{ item.SellingStyleName }} {{ item.Item.SellingStyleNumber }}
                  </div>
                </a>
                </template>
            </div>
            <div v-else>
              <div class="list-item-label-row">
                <span>{{ $resourceString["myBasket.ProductList.Label.Style"] }}:</span>
                <div class="text-uppercase font-weight-bold font-size-item-label">
                  {{ item.SellingStyleName }}
                </div>
              </div>
            </div>
          </div>
          <div class="pb-md-2">
            <div class="list-item-label-row">
              <span>{{ $resourceString["myBasket.ProductList.Label.Color"] }}:</span>
              <div class="font-weight-light cart-item-color-no">
                {{ item.Item.SellingColorNumber }}
              </div>
            </div>
          </div>
          <div class="pb-md-2" v-if="item.Collection && !isContinueShippingModal">
            <div class="list-item-label-row">
              <span>{{ $resourceString["myBasket.ProductList.Label.Collection"] }}:</span>
              <div>
                {{ item.Collection }}
              </div>
            </div>
          </div>
          <div class="pb-md-2" v-if="!isContinueShippingModal">
            <div class="list-item-label-row">
              <span>{{ $resourceString["myBasket.ProductList.Label.Product"] }}:</span>
              <div>
                {{ item.ProductTypeDesc ? item.ProductTypeDesc : "Other" }}
              </div>
            </div>
          </div>
          <div class="pb-md-2" v-if="!isContinueShippingModal">
            <div class="list-item-label-row">
              <span>{{ $resourceString["myBasket.ProductList.Label.Category"] }}:</span>
              <div>
                {{ item.InventoryType }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="!isCheckoutPage && !isContinueShippingModal" class="col-xl-4 col-md-6 col-12 py-3 size-quantity-col">
          <div class="list-item-label-row pb-2 sample-size-box" v-if="!item.Item.IsTrayItem && !item.IsAdditonalItem && !item.IsIdeaBook">
            <span>{{ $resourceString["myBasket.ProductList.Label.SampleSize"] }}:</span>
            <div>
              <div class="select-dropdown-arrow">
                <select name="VehicleId" :disabled="(item.isVehicleIdMatch && item.SampleSizes.length === 1)"
                  @change="onChangeSize(item, index, $event)" :id="item.VehicleId"
                  class="form-control text-uppercase font-size-item-label w-100" required="required">
                  <template v-if="item.isVehicleIdMatch && item.SampleSizes.length === 1">
                    <option :value="item.SampleSizes[0].Value" :selected="true">{{ item.SampleSizes[0].Text }}</option>
                  </template>
                  <template v-else>
                    <option value :selected="true">{{ $resourceString["myBasket.Dropdown.Placeholder.SelectSize"] }}
                    </option>
                    <option v-for="(sizes, indx) in item.SampleSizes" :key="sizes.Value" :value="sizes.Value"
                      :disabled="sizes.Disabled" :selected="item.VehicleId === sizes.Value">
                      {{ sizes.Text }}
                    </option>
                  </template>
                </select>
              </div>
              <div class="field-validation-error text-secondary"
                v-if="!item.Item.IsTrayItem && !item.IsAdditonalItem && !item.IsIdeaBook && item.SampleSizes.length == 0">
                {{ $resourceString["pages.basket.errors.noavailablesize"] }}
              </div>
              <div class="field-validation-error text-secondary" v-else-if="!item.VehicleId">
                {{ $resourceString["myBasket.errors.PleaseSelectSize"] }}
              </div>
            </div>
          </div>

          <div class="quantity-additional-size-box" v-if="!item.Item.IsTrayItem && !item.IsAdditonalItem">
            <div class="quantity-box" v-if="item.VehicleId">
              <div class="list-item-label-row pb-2 sample-size-box">
                <span>{{ $resourceString["myBasket.ProductList.Label.Quantity"] }}:</span>
                <div>
                  <div class="input-group">
                    <button type="button" class="input-group-prepend bg-white border-1 minus"
                      @click="qunatityChange(item, 'minus', index)">
                      -
                    </button>
                    <input id="Quantity" :max="item.SampleAvailability" min="1" name="Quantity"
                      class="basket-quantity-input font-size-item-label" readonly="readonly" type="number"
                      :value="item.Quantity" />
                    <button type="button" class="input-group-append bg-white border-1 plus"
                      @click="qunatityChange(item, 'add', index)">
                      +
                    </button>
                  </div>
                  <div class="field-validation-error text-secondary"
                    v-if="item.Quantity > item.SampleAvailability && item.SampleSizes.length > 0">
                    {{ item.SampleAvailability }} {{ $resourceString["myBasket.errors.IsTheMaximumAvailable"] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="additional-size-box"
              v-if="(item.SampleSizes.length > 1) && (item.SellingStyleName.toLowerCase() !== SellingStyleName && item.InventoryType.toLowerCase() !== InventoryType)">
              <div class="list-item-label-row pb-2">
                <span>{{ $resourceString["myBasket.ProductList.Label.AddAdditionalSize"] }}:</span>
                <div class="text-uppercase font-size-item-label">
                  <div v-for="(sizes, index) in item.SampleSizes" :key="sizes.Value"
                    v-show="item.VehicleId !== sizes.Value" :class="index !== item.SampleSizes.length ? 'pb-2' : ''">
                    <a :href="'#additionalsize'"
                      @click.prevent="addAditionalSize(item.Item.SellingStyleNumber, item.Item.SellingColorNumber, sizes.Value)"
                      class="text-decoration-underline cart-item-model-no">
                      {{ checkSampleType(sizes.Value) }} - {{ sizes.Text }}
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="pb-2" v-else>
            <div class="list-item-label-row">
              <span>{{ $resourceString["myBasket.ProductList.Label.Quantity"] }}:</span>
              <div>
                <div class="font-weight-light cart-item-color-no">
                  {{ item.Quantity }}
                </div>
                <div class="field-validation-error text-secondary"
                  v-if="!item.IsAdditonalItem && !item.IsIdeaBook && item.SampleSizes.length == 0">
                  {{ $resourceString["pages.basket.errors.noavailablesize"] }}
                </div>
                <div class="field-validation-error text-secondary" v-else-if="!item.VehicleId">
                  {{ $resourceString["myBasket.errors.PleaseSelectSize"] }}
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- review basket for checkout -->
        <div v-if="isCheckoutPage" class="col-xl-4 col-md-6 col-12 py-3 size-quantity-col">
          <div class="list-item-label-row pb-2" v-if="!item.Item.IsTrayItem && !item.IsAdditonalItem && !item.IsIdeaBook">
            <span>{{ $resourceString["myBasket.ProductList.Label.SampleSize"] }}:</span>
            <div v-for="(sizes, index) in item.SampleSizes" :key="sizes.Value"
              :class="index !== item.SampleSizes.length ? 'pb-2' : ''" v-if="item.VehicleId === sizes.Value">
              {{ sizes.Text }}
            </div>
          </div>
          <div class="pb-2">
            <div class="list-item-label-row">
              <span>{{ $resourceString["myBasket.ProductList.Label.Quantity"] }}:</span>
              <div class="font-weight-light cart-item-color-no">
                {{ item.Quantity }}
              </div>
            </div>
          </div>
        </div>

        <!-- remove and save for later button -->
        <div v-if="!isCheckoutPage && !isContinueShippingModal"
          class="col-xl-3 col-md-6 col-12 py-3 text-uppercase remove-saveforlater-col">
          <div class="remove-saveforlater-btn-col">
            <a class="remove-btn font-size-item-label" href="#remove" @click.prevent="remove(item)">
              {{ $resourceString["myBasket.Button.Remove"] }}
              <span class="png-icon png-icon-icons-glyph--g-close-sqr-fill"></span>
            </a>
          </div>
          <div class="remove-saveforlater-btn-col">
            <a v-if="!item.Item.IsTrayItem" class="saveforlater-btn font-size-item-label" href="#save"
              @click.prevent="addSaveForLater(item)">
              {{ $resourceString["myBasket.Button.SaveForLater"] }}
            </a>
          </div>
        </div>

      </div>
    </div>

    <div class="basket-page-list-item-clear-all" v-if="isClearAll">
      <a href="#" class="text-uppercase font-size-item-label" @click.prevent="clearItemsBasket">
        {{ clearAllTitle }}
      </a>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ShippingOptions from "./../checkout-page/shipping-options.vue";
import { SAMPLE_TYPE_FULL, SAMPLE_TYPE_CUT, BASKET_TRAYITEMS, BASKET_SITEITEMS, BASKET_PROJECTITEMS } from "../../../constants/checkout-constant";
import { globalIcons } from "../../../constants/global";
export default {
  props: {
    isCheckoutPage: Boolean,
    isBasketPage: Boolean,
    isCheckoutConfirmation: {
      default: false
    },
    listName: {
      required: true
    },
    listItems: {
      required: true
    },
    clearAllTitle: String,
    isClearAll: Boolean,
    isContinueShippingModal: Boolean,
  },
  components: {
    ShippingOptions
  },
  computed: {
    ...mapGetters({
      getFullTypeSizeSamples: "newBasketPage/getFullTypeSizeSamples",
      basketItems: "newBasketPage/getBasketItems",
      saveForLater: "newBasketPage/getSaveForLater",
    })
  },
  data() {
    return {
      SellingStyleName: this.$resourceString["basket.SellingStyleName"],
      InventoryType: this.$resourceString["basket.InventoryType"],
      defaultImage:globalIcons.defaultImage
    };
  },
  methods: {
    ...mapActions({
      postBasket: "newBasketPage/postBasket",
      notificationAdd: "notifications/add",
      updateloader: "newBasketPage/updateLoader",
      addToCart: "newBasketPage/addToCart",
      fetchBasketItem: "newBasketPage/fetchBasketItem",
      updateIdeaBookFlag: "newBasketPage/updateIdeaBookFlag",
      clearBasketItems: "newBasketPage/clearBasketItems",
    }),
    async addAditionalSize(sellingStyleNumber, sellingColorNumber, vehicleId) {
      this.updateloader(true);
      let payload = {
        sellingStyleNumber: sellingStyleNumber,
        colorNumber: sellingColorNumber,
        vehicleId: vehicleId,
        quantity: null,
        saveForLater: false,
        isProjectItem: this.listName === BASKET_PROJECTITEMS ? true : false
      };
      await this.addToCart(payload);
      await this.fetchBasketItem(this.listName);
      this.updateloader(false);
    },
    onChangeSize(item, index, size) {
      item.RequestAction = "update";
      item.VehicleId = size.target.value;
      this.postBasket({
        item: item,
        basketName: this.listName,
        basketIndex: index
      });
    },
    slugify(string) {
      return string.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+|-+$/g, '');
    },
    async qunatityChange(item, type, index) {
      if (type === "minus") {
        if (item.Quantity > 1) {
          this.quantityDecrease(item, index, "decrease");
        }
      } else {       
        if (this.checkQuantityLimit(item)) {
          this.notificationAdd({
            type: "error",
            title: this.$resourceString["common.Notification.Error.Title"],
            description: this.$resourceString["basket.QuantityLimit"]
          });
        } else {
          this.quantityDecrease(item, index, "increase");
        }
      }
    },
    checkQuantityLimit(siteItem) {
          const checkQuantityByItems = (firstItems, secondItems) => {
              if(firstItems && secondItems.length > 0) {
                return secondItems.some(obj => {
                  const isValid =  (firstItems.Item.SellingStyleNumber === obj.Item.SellingStyleNumber) && (firstItems.Item.SellingColorNumber === obj.Item.SellingColorNumber) && (firstItems.VehicleId === obj.VehicleId)
                  if(isValid) {
                    return (firstItems.Quantity + obj.Quantity) >= firstItems.SampleAvailability
                  } else {
                    return firstItems.Quantity >= firstItems.SampleAvailability
                  }
              }) 
            } else {
              return firstItems.Quantity >= firstItems.SampleAvailability
            }        
        }
        if(this.listName === BASKET_SITEITEMS) {
          return checkQuantityByItems(siteItem, this.basketItems.ProjectItems)
        } else {
          return checkQuantityByItems(siteItem, this.basketItems.SiteItems)
        }      
    },
    async quantityDecrease(item, index, type) {
      item.RequestAction = "update";
      if (type === "decrease") {
        if (item.Quantity > item.SampleAvailability) {
          item.Quantity = item.SampleAvailability;
        } else {
          item.Quantity = item.Quantity - 1;
        }
      } else {
        item.Quantity = item.Quantity + 1;
      }
      await this.postBasket({
        item: item,
        basketName: this.listName,
        basketIndex: index
      });
    },
    checkSampleType(vehicleIdValue) {
      let isFullSize = this.getFullTypeSizeSamples.find(({ Key, Value }) => Key === vehicleIdValue && Value === true);
      if (isFullSize) {
        return SAMPLE_TYPE_FULL;
      } else {
        return SAMPLE_TYPE_CUT;
      }
    },
    async remove(item) {
      if (item.VehicleId === this.basketItems.LatestIdeaBook.IdeabookVehicleId && item.IsIdeaBook) {
        this.updateIdeaBookFlag(false);
        this.$cookies.set("ideaBook", false, "1m");
      } else {
        item.RequestAction = "remove";
        await this.postBasket({
          item: item,
          basketName: this.listName
        });
      }
    },
    async addSaveForLater(item) {
      if (this.saveForLater.SiteItems.length >= 14 && this.listName === BASKET_SITEITEMS) {
        this.notificationAdd({
          type: "error",
          title: this.$resourceString["common.Notification.Error.Title"],
          description: this.$resourceString["basket.SaveForLater.Limiterror"]
        });
      } else if (this.saveForLater.ProjectItems.length >= 14 && this.listName === BASKET_PROJECTITEMS) {
        this.notificationAdd({
          type: "error",
          title: this.$resourceString["common.Notification.Error.Title"],
          description: this.$resourceString["basket.SaveForLater.Limiterror"]
        });
      } else {
        item.RequestAction = "save";
        await this.postBasket({
          item: item,
          basketName: this.listName
        });
      }
    },
    clearItemsBasket() {
      const cartSettings = {
        [BASKET_SITEITEMS]: { isTrayCart: false, isProjectCart: false },
        [BASKET_PROJECTITEMS]: { isTrayCart: false, isProjectCart: true },
        [BASKET_TRAYITEMS]: { isTrayCart: true, isProjectCart: false }
      }
      const payload = cartSettings[this.listName] || {}
      this.clearBasketItems(payload);
    },
    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
  }
};
</script>
